export default __webpack_public_path__ + "static/media/book.cdc95ca0.png";